import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Manage Columns',
    description: 'editColumnsModal.manageColumns',
    id: 'mvEawl',
  },
  cancel: {
    defaultMessage: 'Cancel',
    description: 'editColumnsModal.cancel',
    id: '9FcK5S',
  },
  save: {
    defaultMessage: 'Save Columns',
    description: 'editColumnsModal.saveColumns',
    id: 'Q3bq7U',
  },
  deselectAll: {
    defaultMessage: 'Deselect All',
    description: 'editColumnsModal.deselectAll',
    id: '6sJohZ',
  },
  selectedCount: {
    defaultMessage: '{count} selected',
    description: 'editColumnsModal.selectedCount',
    id: 'CNdaho',
  },
});
